import React from 'react';
import { useColorScheme } from '../contexts/ColorSchemeContext';

const Footer = () => {
  const { getColorClasses } = useColorScheme();
  const colors = getColorClasses();

  return (
    <footer className="bg-transparent py-8">
      <div className="container mx-auto px-4 text-center space-y-3">
        {/* Motivational Tagline */}
        <p className={`text-lg font-medium accent-gradient-text`}>
          Learning, building, and sharing knowledge
        </p>
        
        {/* Tech Stack */}
        <p className={`${colors.textSecondary} text-sm`}>
          Built with React, JavaScript, Tailwind CSS
        </p>
        
        {/* Personal Touch */}
        <p className={`${colors.textMuted} text-sm`}>
          Made with <span className="text-[var(--color-primary)]" style={{ color: 'var(--color-primary)' }}>♥</span> by Ashraf Ali
        </p>
      </div>
    </footer>
  );
};

export default Footer;
